const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "LICENCE_APPLICATION_TYPES_RETRIEVED":
            return action.licenceApplicationTypes;

        default:
            return state;
    }
}
